export default () => ({
	init() {
		this.$el
			.querySelectorAll('[data-boldfix]')
			.forEach((e) => (e.dataset.boldfix = e.innerText));
	},
});
